import { SVLoader } from '@/components/core';
import ExternalAccountDetailsButton from '@/components/externalAccounts/details/ExternalAccountDetailsButton';
import ExternalAccountDetailsCards from '@/components/externalAccounts/details/ExternalAccountDetailsCards';
import ExternalAccountDocuments from '@/components/externalAccounts/details/ExternalAccountDocuments';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import { ROUTES } from '@/constants/routes';
import { useGetExternalAccountDetails } from '@/hooks/requests/useExternalAccounts';
import { titleCase } from '@/utils/stringCaser';
import { Card, Stack, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';

export default function ExternalAccountsDetailsPage() {
  const { uuid = '' } = useParams();
  const { externalAccountDetails, isExternalAccountDetailsPending } =
    useGetExternalAccountDetails(uuid);

  if (isExternalAccountDetailsPending) {
    return (
      <DefaultLayout header="External Account Details">
        <Card>
          <SVLoader />
        </Card>
      </DefaultLayout>
    );
  }

  if (!externalAccountDetails) {
    return (
      <DefaultLayout header="External Account Details">
        <Card>
          <Typography>
            Something went wrong retreiving the external account. Our team has
            been notified.
          </Typography>
        </Card>
      </DefaultLayout>
    );
  }

  const { bankName, category, accountNumberLast4, owner, proofsOfOwnership } =
    externalAccountDetails;
  const header = `${bankName} ${titleCase(category)} ...${accountNumberLast4}`;

  return (
    <DefaultLayout
      header={header}
      buttons={[
        <ExternalAccountDetailsButton
          key="buttons"
          externalAccountDetails={externalAccountDetails}
        />,
      ]}
      breadcrumb={[
        {
          label: 'Customers',
          href: ROUTES.CUSTOMERS,
        },
        { label: owner.fullName, href: `${ROUTES.CUSTOMERS}/${owner.uuid}` },
        {
          label: 'External Accounts',
          href: `${ROUTES.CUSTOMERS}/${owner.uuid}/external-accounts`,
        },
        { label: header, isActive: true },
      ]}>
      <Stack spacing={2}>
        <ExternalAccountDetailsCards
          externalAccountDetails={externalAccountDetails}
        />
        <ExternalAccountDocuments uuid={uuid} documents={proofsOfOwnership} />
      </Stack>
    </DefaultLayout>
  );
}
